module.exports = __webpack_public_path__ + "assets/icons/ic_keyboard_arrow_down-929f.svg";